// ###collection-banner ### 

 if (!customElements.get('collection-banner-wrapper')) {
    customElements.define('collection-banner-wrapper', class extends HTMLElement {
      connectedCallback() {
        // Defer initialization to ensure inner HTML is fully parsed by the browser
        setTimeout(() => {
          this.init();
        }, 0);
      }

      init() {
        this.desc = this.querySelector('.collection-hero__description');
        this.btn = this.querySelector('.readmore-link');
        
        // If elements still aren't ready, try again in 50ms
        if (!this.desc || !this.btn) {
          setTimeout(() => this.init(), 50);
          return;
        }

        this.checkHeight = this.checkHeight.bind(this);
        
        // 1. Run immediately now that DOM is ready
        this.checkHeight();

        // 2. Run after a short delay to catch late CSS/font rendering
        setTimeout(this.checkHeight, 100);
        setTimeout(this.checkHeight, 500);
        
        // 3. Observe for layout shifts
        if (typeof ResizeObserver !== 'undefined') {
          this.ro = new ResizeObserver(this.checkHeight);
          this.ro.observe(this.desc);
        }
        
        window.addEventListener('load', this.checkHeight);
        window.addEventListener('resize', this.checkHeight);
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('load', this.checkHeight);
        window.removeEventListener('resize', this.checkHeight);
      }

      checkHeight() {
        if (!this.offsetParent) return; // Skip if hidden by CSS (mobile/desktop toggle)
        
        // 100px is max-height. 102px allows a tiny buffer for sub-pixel rendering.
        if (this.desc.scrollHeight > 102) {
          this.btn.style.display = 'inline-block';
        } else {
          this.btn.style.display = 'none';
          this.desc.classList.remove('expanded');
        }
      }
    });

    // Global click listener for the toggle (Event Delegation)
    document.addEventListener('click', function(event) {
      if (event.target.matches('.readmore-link')) {
        const wrapper = event.target.closest('collection-banner-wrapper');
        if (!wrapper) return;
        
        const description = wrapper.querySelector('.collection-hero__description');
        if (description) {
          if (description.classList.contains('expanded')) {
            description.classList.remove('expanded');
            event.target.textContent = 'Read More ▼';
          } else {
            description.classList.add('expanded');
            event.target.textContent = 'Read Less ▲';
          }
        }
      }
    });
  }

  //### subcat-blocks ###

    if (!customElements.get('sub-category-wrapper')) {
    customElements.define('sub-category-wrapper', class extends HTMLElement {
      connectedCallback() {
        // Defer initialization to ensure inner HTML is fully parsed by the browser
        setTimeout(() => {
          this.init();
        }, 0);
      }

      init() {
        if (window.location.search.includes('filter')) {
          this.style.display = 'none';
          return;
        }

        this.block = this.querySelector('.sub-cat-block');
        this.tabs = this.block ? this.block.querySelectorAll('.sub-cat-tab') : [];
        
        // If elements still aren't ready, try again in 50ms
        if (!this.block || this.tabs.length === 0) {
          setTimeout(() => this.init(), 50);
          return;
        }

        // Bind methods so 'this' refers to the custom element
        this.calculateRows = this.calculateRows.bind(this);
        this.checkMobileScroll = this.checkMobileScroll.bind(this);

        // 1. Run immediately now that DOM is ready
        this.calculateRows();
        
        // 2. Run after a short delay to catch late CSS rendering
        setTimeout(this.calculateRows, 100);
        setTimeout(this.calculateRows, 500);
        
        // 3. Run when the full page (including all images) has finished loading
        window.addEventListener('load', this.calculateRows);
        
        this.block.addEventListener('scroll', this.checkMobileScroll, { passive: true });
        
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(() => {
            requestAnimationFrame(this.calculateRows);
          });
          this.resizeObserver.observe(this.block);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.block) this.block.removeEventListener('scroll', this.checkMobileScroll);
        window.removeEventListener('load', this.calculateRows);
      }

      checkMobileScroll() {
        if (!this.offsetParent) return; // Skip if element is hidden by CSS
        
        if (window.innerWidth >= 750) {
          this.classList.remove('has-right-fade');
          return;
        }
        
        const isScrollable = this.block.scrollWidth > this.block.clientWidth;
        if (isScrollable) {
          const isAtEnd = Math.ceil(this.block.scrollLeft + this.block.clientWidth) >= this.block.scrollWidth - 1;
          this.classList.toggle('has-right-fade', !isAtEnd);
        } else {
          this.classList.remove('has-right-fade');
        }
      }

      calculateRows() {
        // offsetParent is null if the element or any ancestor has display: none
        // This prevents the hidden duplicate block from calculating incorrectly
        if (!this.offsetParent) return; 

        if (window.innerWidth < 750) {
          this.classList.remove('is-collapsable');
          this.checkMobileScroll();
          return;
        }

        const blockRect = this.block.getBoundingClientRect();
        const rowTops = new Set();
        
        this.tabs.forEach(tab => {
          const topRel = tab.getBoundingClientRect().top - blockRect.top;
          rowTops.add(Math.round(topRel / 5) * 5);
        });

        const uniqueTops = Array.from(rowTops).sort((a, b) => a - b);

        if (uniqueTops.length > 2) {
          this.classList.add('is-collapsable');
          this.block.style.setProperty('--collapsed-height', uniqueTops[2] + 'px');
          
          if (!this.querySelector('.sub-cat-toggle')) {
            const toggleBtn = document.createElement('button');
            toggleBtn.className = 'sub-cat-toggle';
            toggleBtn.setAttribute('aria-label', 'Toggle subcategories');
            toggleBtn.innerHTML = '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.53033 9.53033L0.46967 3.46967L1.53033 2.40901L7 7.87868L12.4697 2.40901L13.5303 3.46967L7.46967 9.53033C7.17678 9.82322 6.82322 9.82322 6.53033 9.53033Z" fill="currentColor"></path></svg>';
            
            this.appendChild(toggleBtn);

            toggleBtn.addEventListener('click', () => {
              this.classList.toggle('is-expanded');
            });
          }
        } else {
          this.classList.remove('is-collapsable');
          const btn = this.querySelector('.sub-cat-toggle');
          if (btn) btn.remove();
        }
      }
    });
  }
//### sidebar-subcategories ###

      if (!customElements.get('sidebar-subcategories')) {
      customElements.define('sidebar-subcategories', class extends HTMLElement {
        connectedCallback() {
          setTimeout(() => {
            this.init();
          }, 0);
        }

        init() {
          if (window.location.search.includes('filter')) {
            this.style.display = 'none';
            return;
          }

          this.wrapper = this.querySelector('.sidebar-subcategories__list-wrapper');
          this.items = this.querySelectorAll('.sidebar-subcategories__item');
          this.toggleBtn = this.querySelector('.sub-cat-toggle');

          if (this.items.length > 8 && this.toggleBtn) {
            this.calculateHeight = this.calculateHeight.bind(this);
            
            this.calculateHeight();
            
            window.addEventListener('load', this.calculateHeight);
            window.addEventListener('resize', this.calculateHeight);

            this.toggleBtn.addEventListener('click', () => {
              this.classList.toggle('is-expanded');
            });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('load', this.calculateHeight);
          window.removeEventListener('resize', this.calculateHeight);
        }

        calculateHeight() {
          if (!this.offsetParent) return; 

          const wrapperTop = this.wrapper.getBoundingClientRect().top;
          const eighthItemBottom = this.items[7].getBoundingClientRect().bottom;
          const collapsedHeight = eighthItemBottom - wrapperTop;

          this.style.setProperty('--sidebar-collapsed-height', collapsedHeight + 'px');
        }
      });
    }